// Hooks/useUploadCsv.js
import { useState, useCallback } from "react";
import { fetchWithAuth } from "../Utils/fetchWithAuth";

export default function useUploadCsv() {
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState(null);
  const [data, setData]     = useState(null);

  const uploadCsv = useCallback(async (url, file) => {
    setLoading(true);
    setError(null);
    setData(null);
    try {
      if (!file) throw new Error("Nessun file selezionato.");
      const fd = new FormData();
      fd.append("file", file, file.name);

      // Assicura trailing slash se serve
      const safeUrl = url.endsWith("/") ? url : url + "/";

      const res = await fetchWithAuth(safeUrl, {
        method: "POST",
        body: fd,
        isFormData: true,      // <— chiave di tutto
      });

      if (!res) throw new Error("Sessione non valida.");
      const text = await res.text().catch(() => "");

      if (!res.ok) {
        const msg = text || `Errore ${res.status}`;
        throw new Error(msg);
      }

      setData(text || "OK");
      return { ok: true, payload: text };
    } catch (e) {
      setError(e);
      return { ok: false, error: e };
    } finally {
      setLoading(false);
    }
  }, []);

  return { uploadCsv, loading, error, data };
}
